// authConfig.js - MSAL Configuration
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "YOUR_CLIENT_ID",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || "YOUR_TENANT_ID"}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "Sites.ReadWrite.All"],
};

export const mailSendRequest = {
  scopes: ["Mail.Send"],
};

// Incremental consent scopes for O365 people search (requested on demand)
export const userSearchRequest = {
  scopes: ["User.ReadBasic.All"],
};

export const peopleRequest = {
  scopes: ["People.Read"],
};

// Requested on demand by the provisioning owner: create SharePoint lists, columns and indexes
export const provisionRequest = {
  scopes: ["Sites.Manage.All"],
};

// The only accounts that see the SharePoint Schema menu, page and auto-provisioning.
// Comma-separated override: REACT_APP_PROVISIONING_OWNERS
export const provisioningOwners = (process.env.REACT_APP_PROVISIONING_OWNERS || "jastistech@lekoil.com")
  .split(",").map((e) => e.trim().toLowerCase()).filter(Boolean);

export const sharePointConfig = {
  siteUrl:
    process.env.REACT_APP_SHAREPOINT_SITE_URL ||
    "https://lekoillimited.sharepoint.com/sites/SCMDashboard",
  listName: process.env.REACT_APP_SHAREPOINT_LIST_NAME || "SCMWeeklyData",
  schemaListName:
    process.env.REACT_APP_SHAREPOINT_SCHEMA_LIST || "SCMEntitySchema",
};
